import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Icon, useQueryClient } from "@project/ui";
import { cn } from "@project/ui";
import { authClient } from "@apps/dashboard/lib/auth-client";
import { useI18n } from "@apps/dashboard/contexts/I18nContext";
import { afterDashboardSignOut } from "@apps/dashboard/lib/after-dashboard-sign-out";
import { dashboardPaths } from "@apps/dashboard/lib/routes";

export function SignOutButton({ className, onDone }: { className?: string; onDone?: () => void }): JSX.Element {
  const { t } = useI18n();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [busy, setBusy] = useState(false);

  async function handleSignOut(): Promise<void> {
    setBusy(true);
    try {
      await authClient.signOut();
      afterDashboardSignOut(queryClient);
      navigate(dashboardPaths.login, { replace: true });
    } finally {
      setBusy(false);
      onDone?.();
    }
  }

  return (
    <button
      type="button"
      onClick={() => void handleSignOut()}
      disabled={busy}
      className={cn(
        "flex w-full items-center gap-3 rounded-lg px-4 py-2 font-label text-label-md text-on-surface-variant transition-colors hover:text-error disabled:opacity-50",
        className
      )}
    >
      <Icon name="LogOut" className="size-4 shrink-0" strokeWidth={1.5} aria-hidden />
      {t("auth.logout")}
    </button>
  );
}
